const messages = {
  unnamed: '--unnamed--',
  id: 'ID',
  all: '--All--',
  not_used: '--Not used--',
  account: '',
  data: 'Data',
  pieces: 'pc.',
  placeholder_hm: 'HH:MM',
  placeholder_hms: 'HH:MM:SS',
  amount: 'Amount',
  balance: 'Balance',
  bulk_id: 'Bulk ID',
  detail: 'Detail',
  detail_info: 'Message info',
  detail_incoming: 'Detail statistic of incoming',
  description: 'Description',
  error: 'Error',
  error_code: 'Error code',
  error_description: 'Error description',
  emailAttachedFilesSizeLimit: 'Could not attach the file {filename} - the size of the attachment files exceeds 25 megabytes',
  group: 'Group statistic',
  group_by: 'Group by',
  group_by_optionally: 'Additionally group by',
  group_incoming: 'Group statistic of incoming',
  message: 'Message',
  message_type: 'Message type',
  message_length: 'Message length',
  message_parts: 'Number of message parts',
  message_category: 'Message category',
  name: 'Name',
  originators: 'Originators',
  overdraft: 'Overdraft',
  partner: 'Client',
  partners: 'Clients',
  partner_user: 'User',
  partner_price: 'Price',
  price: 'Price',
  priority: 'Priority',
  provider_price: 'Provider price',
  proceed: 'Proceed',
  choose_payment_system: 'Choose payment system',
  topup_balance: 'Top up balance',
  quantity: 'Quantity',
  rule: 'Rule',
  service_provider: 'Service provider',
  service_providers: 'Service providers',
  source: 'Source',
  status: 'Status',
  template: 'Template',
  templates: 'Templates',
  template_id: 'Template ID',
  templates_new: 'Create template',
  templates_edit: 'Edit template',
  timeout: 'Timeout',
  transport: 'Transport',
  file: 'File',
  variables: 'Variables',
  first_name: 'Name',
  email: 'Email',
  password: 'Password',
  confirm_password: 'Confirm password',
  timezone: 'Time zone',
  show_finance_info: 'Show financial information',
  is_check_pass: 'Change password at next login',
  show_finance_info: 'Show financial information',
  pages: 'Pages',
  role: 'Role',
  role_use: 'Is use the role',
  role_settings: 'Role settings',
  without_role: '--Without role--',
  msisdn: 'MSISDN',
  company: 'Company',
  filters: 'Filters',
  filters_additional: 'Additional filters',
  filter_hide: 'Hide filter',
  filters_clear: 'Clear filters',
  filter: 'Filter',
  group_settings: 'Group settings',
  search: 'Search',
  create: 'Create',
  add: 'Add',
  save: 'Save',
  back_to_list: 'Back to list',
  remove: 'Remove',
  apply: 'Apply',
  export: 'Export',
  import: 'Import',
  download: 'Download',
  upload: 'Upload',
  cancel: 'Cancel',
  confirm: 'Ок',
  logout: 'Logout',
  resend: 'Resend',
  back: 'Back',
  display_charts: 'Show graphics',
  attach: 'Attach',
  next: 'Next',
  previous: 'Back',
  tableEmpty: 'Set search parameters <br> to get results',
  browserNotSupport: 'This browser not supported',
  audio_not_supported: 'Your browser does not support audio playback',
  forbidden: 'Forbidden',
  absent: 'Absent',
  base_settings: 'Base preferences',
  additional_settings: 'Additional preferences',
  cascading: 'Cascading',
  scheduler: 'Scheduler',
  smpp_settings: 'Settings SMPP account',
  http_settings: 'Settings HTTP account',
  allowed_operators: 'Allowed service providers',
  newTemplate: 'New template',
  button_link: 'Link to go',
  active: 'Activity',
  lifetime: 'Message lifetime (s)',
  blacklist: 'Black list',
  max_throughput: 'Sending rate per second',
  statistic: 'Display text in statistics',
  use_cascading: 'Use cascading',
  channel: 'Channel',
  multichannel_chanel: 'Chanel',
  multichannel_template_name: 'Template',
  multichannel_timeout: 'Timeout',
  tooltip_timeout: 'Time in format HH:MM:SS, after which the sending will be carried out via an alternative channel',
  tooltip_addressbookcontact_duplicate: 'A complete match by MSISDN and Email with another contact of the group is considered a duplicate. It is impossible to keep such a contact.',
  tooltip_blacklistcontact_duplicate: 'A complete match by MSISDN and Email with another blacklist contact is considered a duplicate. It is impossible to keep such a contact.',
  send_date: 'Send date',
  send_time: 'Send time',
  allowed_days: 'Days of sending',
  send_evenly: 'Even distribution',
  translit: 'Transliteration',
  char_entered: 'Characters entered',
  author: 'Author',
  editDate: 'Edit date',
  comment: 'Comment',
  title: 'Title',
  content: 'Content',
  choose_application: 'Choose application',
  startDate: 'Date from',
  endDate: 'Date to',
  date_from: 'Date from',
  date_to: 'Date to',
  sent_date_from: 'Sent date from',
  sent_date_to: 'Sent date to',
  deliver_date_from: 'Delivery date from',
  deliver_date_to: 'Delivery date to',
  defer_date: 'Defer date',
  sent_date: 'Sent date',
  read_date: 'Read date',
  account_name: 'Account name',
  protocol: 'Protocol',
  push_statuses: 'Automatic receipt of delivery statuses',
  status_report: 'Report statuses',
  immediate_response_needed: 'Return submit_sm_resp immediately',
  for_all: 'All',
  final: 'Final',
  broker_api_doc: 'Broker-api documentation',
  originator: 'Originator',
  originator_address: 'Originator address',
  originator_operator: 'Operator',
  originator_country: 'Country',
  recipient: 'Recipient',
  recipient_region: 'Region',
  recipient_country: 'Country',
  operator: 'Operator',
  service_provider: 'Service provider',
  mcc: 'MCC',
  mnc: 'MNC',
  broker_account_login: 'Account',
  partner_user_login: 'Client',
  smpp_message_id: 'SMPP ID',
  module: 'SMPP-connect',
  external_id: 'External ID',
  create_date: 'Create date',
  postponed_date: 'Postponed date',
  send_date: 'Sent date',
  delivery_date: 'Delivery date',
  source_type: 'Source type',
  parent_message_id: 'Parent message ID',
  parent_message_channel: 'Parent message channel',
  connection_type: 'Connection type',
  ext_id1: 'Ext_ID 1',
  ext_id2: 'Ext_ID 2',
  ext_id3: 'Ext_ID 3',
  ext_id4: 'Ext_ID 4',
  ext_id5: 'Ext_ID 5',
  service_number: 'Number',
  connectionType: 'Connection type',
  country: 'Country',
  msgParts: 'Number of segments',
  createDate: 'Create date',
  create_date: 'Create date',
  deliveryDate: 'Delivery date',
  readDate: 'Read date',
  duration: 'Duration',
  application: 'Application',
  platform: 'Operating system',
  os: 'Operating system',
  os_version: 'OS version',
  sdk_version: 'SDK version',
  mapp_version: 'Mapp version',
  by_number: 'by number',
  by_filter: 'by filter',
  client_filter: 'Client filter',
  device_filter: 'Device filter',
  finishDate: 'Finish date',
  finish_date: 'Finish date',
  sender: 'Sender',
  charged: 'Charged',
  subject: 'Subject',
  message_text: 'Message text',
  show_message_text: 'Show message text',
  message_text_empty: 'Empty message',
  call_events: 'Call events',
  show_call_events: 'Show call events',
  mnService: 'Mail Notify Service',
  mnTemplate: 'Mail Notify Template',
  mnRoutes: 'List of social networks to send',
  vkMessage: 'Message for VK',
  okMessage: 'Message for OK',
  empty: 'Empty',
  date: 'Date',
  transmitted: 'Transmitted',
  transmitted_parts: 'Transmitted (parts)',
  sent: 'Sent',
  delivered: 'Delivered',
  delivered_parts: 'Delivered (parts)',
  not_delivered: 'Not delivered',
  not_delivered_parts: 'Not delivered (parts)',
  expired: 'Expired',
  expired_parts: 'Expired (parts)',
  failed: 'Failed',
  failed_parts: 'Failed (parts)',
  error: 'Error',
  read: 'Read',
  rejected: 'Rejected',
  rejected_parts: 'Rejected (parts)',
  deferred: 'Deferred',
  deferred_parts: 'Deferred (parts)',
  buffered: 'Buffered',
  not_answered: 'Not answered',
  finished: 'Finished',
  duration: 'Duration',
  charged: 'Charged',
  CallsCount: 'Count',
  All: 'All',
  total: 'Total',
  total_parts: 'Total (parts)',

  auth: {
    title: 'Personal Account',
    description: 'Log in',
    changing_title: 'According to the security policy, you need to change your password',
    button: 'Log in',
    back: 'To the login page',
    change_password: 'Change password',
    language: 'Language',
    email: 'Email',
    username: 'Email / AD login',
    login: 'Username',
    password: 'Password',
    new_password: 'New password',
    confirm_new_password: 'Confirm new password',
    authorization: 'Authorization',
    registration: 'Registration',
    captcha: 'Enter the code from the image',
    code: 'Code from the email message',
    forgot_password: 'Forgot password',
    send_link: 'Send link',
    reset_password: 'Reset password',
    reset_password_description: 'Enter your email address to send a link to reset your password',
  },

  errors: {
    internal: 'Internal server error.',
    request: 'Missing mandatory parameters or request syntax error',
    violation: 'A record with identical parameter(s) already exists',
    not_found: 'Record not found',
    invalid_credentials: 'Unable to log in.<br>Incorrect username/password.',
    invalid_start_end_time: 'Invalid start/end time',
    present_dependence: 'Dependency is present in the data',
    user_locked: 'Unable to log in.<br>Your account is blocked.',
    unauthorized: 'Access error',
    invalid_email_address: 'Invalid email address',
    invalid_email_provider: 'Denied email provider',
    invalid_file_name: 'Unable to upload file.<br>Invalid file name.',
    invalid_file_extension: 'Unable to upload file.<br>Unauthorized file extension.',
    invalid_file_size: 'Unable to upload file.<br>File size must be less than 20 megabytes',
    invalid_call_sender: 'Call sender name must be shorter than 15 digits',
    invalid_sms_sender: 'SMS sender name must not contain forbidden characters',
    not_active_user: 'This user is offline',
    not_active_client: 'This client is offline',
    draft_exists: 'Unable to save draft.<br>Draft already exists for this template.',
    passwords_not_equals: 'Profile data cannot be saved.<br>Passwords do not match.',
    password_already_used: 'Profile data cannot be saved.<br>This password has already been used, choose another password.',
    file_parse_error: 'File cannot be downloaded.<br>File parsing error: fields mismatch.',
    password_difference_symbols: 'It is impossible to change the password.<br>The new password must differ from the previous one by at least',
    password_length: 'It is impossible to change the password.<br>The new password must have a length of at least',
    user_temporary_locked: 'It is impossible to log in.<br>Your account is blocked due to multiple incorrect login/password entry.',
    user_locked_by_system: 'It is impossible to log in.<br>Your account is blocked because You have not logged in for more than {0}.',
    ad_connection_error: 'It is impossible to log in.<br>Active Directory connection settings are not set.',
    ad_login_exist: 'It is impossible to log in.<br>A user with this login is already in the System.',
    no_data_to_export: 'It is impossible to export.<br>There is no data for export.',
    no_data_to_show: 'No data to show',
    addressbookcontact_duplicate: 'It is impossible to save the contact. Contact with the same data already exists in this group',
    blacklistcontact_duplicate: 'It is impossible to save the contact. Contact with the same data already exists in this black list.',
    loop_in_cascading_chain: 'It is impossible to create a distribution. Cascading sending may be looped in a template with the {template ID} of the {transport} channel.',
    loop_in_cascading_chain_template: 'The template cannot be saved. Cascading sending may be looped in a template with the {template ID} of the {transport} channel.',
    active_directory_server_unavaible: 'It is impossible to log in. The Active Directory server is unavailable',
    system_setting_value_is_not_set: 'The request cannot be executed. The required system setting is not set',
    file_is_too_long: 'The file cannot be imported. There are too many entries in the imported file',

    unable_data: 'Unable to get data. Required parameters not set:',
    invalid_date_format: 'Invalid date format',
    invalid_date_interval: 'Unable to get data. Incorrect date interval',
    forbidden: 'Unable to get data. Access to the page is not allowed',
    transport_not_allowed: 'Data cannot be retrieved. Transport is not allowed',
    server_unavaible: 'The request cannot be executed. The application server is unavailable',
    incorrect_confirm_code: 'Invalid email confirmation code',
    registration_error: 'Registration error',
    captcha_failed: 'Captcha verification failed',
    no_partner_user_found: 'The user of the personal account with such an e-mail is not in the system',
    change_password_limit: 'Exceeded the number of attempts to change the password during the specified time',
    change_password_link_expired: 'The waiting time for password reset at this link has been exceeded',
    change_password_attempts_exceeded: 'Exceeded the number of attempts to change the password during the specified time',
    captcha_verification_error: 'Invalid captcha code',
  },

  dialog: {
    confirm: 'Save changes?',
    delete: 'Are you sure you want to delete the entry?',
    error: 'Error detected',
    warning: 'WARNING!',
    success: 'Operation completed successfully',
    export: 'Report successfully exported',
    resend: 'The message will be resent',
    yes: 'Yes',
    no: 'No',
    not_selected_transport: 'You must select at least one transport',
    delete_all_default_category: 'Applying a default category category will remove all associated regular hits for that transport. Do you really want to continue?',
    delete_all_tarifzone: 'All associated regular expressions and rate zone settings will be removed'
  },

  pages: {
    dashboard: 'Dashboard',

    user: 'Profile',
    user_profile: 'Personal data',

    finances: 'Financial management',
    balances: 'Balance history',

    distribution: 'Distributions',
    distribution_list: 'Distribution statuses',
    distribution_sms_new: 'Create SMS-distribution',
    distribution_call_new: 'Create Call-distribution',
    distribution_email_new: 'Create Email-distribution',
    distribution_push_new: 'Create Push-distribution',
    distribution_viber_new: 'Create Viber-distribution',
    distribution_whatsapp_new: 'Create WhatsApp-distribution',
    distribution_custom_new: 'Create Custom-distribution',
    distribution_mail_notify_new: 'Create Mail Notify distribution',

    distribution_template: 'Templates',
    distribution_template_sms: 'SMS templates',
    distribution_template_sms_new: 'Create template of SMS distribution',
    distribution_template_sms_edit: 'Edit template of SMS distribution',
    distribution_template_call: 'Call templates',
    distribution_template_call_new: 'Create template of Call distribution',
    distribution_template_call_edit: 'Edit template of Call distribution',
    distribution_template_call_sound: 'Sounds',
    distribution_template_email: 'Email templates',
    distribution_template_email_new: 'Create template of Email distribution',
    distribution_template_email_edit: 'Email template of Email distribution',
    distribution_template_push: 'Push templates',
    distribution_template_push_new: 'Create template of Push distribution',
    distribution_template_push_edit: 'Edit template of Push distribution',
    distribution_template_viber: 'Viber templates',
    distribution_template_viber_new: 'Create template of Viber distribution',
    distribution_template_viber_edit: 'Edit template of Viber distribution',
    distribution_template_whatsapp: 'WhatsApp templates',
    distribution_template_whatsapp_new: 'Create template of WhatsApp distribution',
    distribution_template_whatsapp_edit: 'Edit template of WhatsApp distribution',
    distribution_template_custom: 'Custom templates',
    distribution_template_custom_new: 'Create template of Custom distribution',
    distribution_template_custom_edit: 'Edit template of Custom distribution',
    distribution_template_mail_notify: 'Mail Notify templates',
    distribution_template_mail_notify_new: 'Create template of Mail Notify distribution',
    distribution_template_mail_notify_edit: 'Edit template of Mail Notify distribution',

    accounts: 'Accounts',
    accounts_new:'Create account',
    accounts_edit:'Edit account',

    sender: 'Senders',
    sender_new: 'Create sender',

    contacts: 'Contacts',
    address_book_group: 'Address book',
    address_book_group_new: 'Create group contacts',
    address_book_group_edit: 'Edit group contacts',
    address_book_group_contact: 'Group contacts',
    address_book_group_contact_new: 'Create contact in group',
    address_book_group_contact_edit: 'Edit contact in group',
    black_list_group: 'Blacklists',
    black_list_group_new: 'Create blacklist',
    black_list_group_edit: 'Edit blacklist',
    black_list_group_contact: 'Contacts in blacklist',
    black_list_group_contact_new: 'Create contact in blacklist',
    black_list_group_contact_edit: 'Edit contact in blacklist',

    report_detailed: 'Detail reports',
    report_detailed_sms: 'SMS detail report',
    report_detailed_sms_info: 'Message Information',
    report_detailed_call: 'Call detail report',
    report_detailed_call_info: 'Message Information',
    report_detailed_email: 'Email detail report',
    report_detailed_email_info: 'Message Information',
    report_detailed_push: 'Push detail report',
    report_detailed_push_info: 'Message Information',
    report_detailed_viber: 'Viber detail report',
    report_detailed_viber_info: 'Message Information',
    report_detailed_whatsapp: 'WhatsApp detail report',
    report_detailed_whatsapp_info: 'Message Information',
    report_detailed_custom: 'Custom detail report',
    report_detailed_custom_info: 'Message Information',
    report_detailed_mail_notify: 'Mail Notify detail report',
    report_detailed_mail_notify_info: 'Message Information',

    report_group: 'Group reports',
    report_group_sms: 'SMS group report',
    report_group_call: 'Call group report',
    report_group_email: 'Email group report',
    report_group_push: 'Push group report',
    report_group_viber: 'Viber group report',
    report_group_whatsapp: 'WhatsApp group report',
    report_group_custom: 'Custom group report',
    report_group_mail_notify: 'Mail Notify group report',
    report_group_summary: 'Summary report',

    report_export: 'Export reports',
  },

  dashboard: {
    distributions: 'Distributions',
    IN_PROGRESS: 'In progress',
    STOPPED: 'Stopped',
    PAYMENT_WAITING: 'Payment waiting',
    ON_MODERATION: 'On moderation',
    FINISHED: 'Finished',
    templates: 'Templates',
    addressBooks: 'Address books',
    addressBooks_count: 'Groups count',
    addressBooks_contacts: 'Contacts count',
    blacklists: 'Blacklists',
    blacklists_count: 'Blacklists count',
    blacklists_contacts: 'Contacts count',
    sended: 'Sent',
    today: 'Today',
    yesterday: 'Yesterday',
    month: 'Month',
    chart_title: 'Last month traffic',
  },

  template: {
    statuses: {
      Active: 'Active',
      NotActive: 'Not active',
      ForModeration: 'Awaiting moderation',
      OnModeration: 'On moderation',
      ForEdit: 'Editing',
      Denied: 'Denied',
      Approved: 'Approved',
    },
    draft: {
      has: 'The template has a draft',
      no: 'Editing is not possible',
      goto: 'Go to draft?',
      create: 'Create a draft?',
      edit_forbidden: 'Editing is not possible',
      replace: 'Delete the draft and create a new one?',
    },
    gotoOriginal: 'Go to template?',
    moderate: 'Send for moderation',
    moderationDescription: 'If You want to change the template name, specify a name other than the current one. The specified name will replace the current one after passing moderation',
    email: {
      message: 'Message',
      subject: 'Subject',
      email_from: 'Email from',
      attaches: 'Attachments',
    },
    viber: {
      pic_link: 'Picture link',
      button_name: 'Button name',
      button_link: 'Button link',
    },
    call: {
      payloadType: 'Message type',
      repeat_flag: 'Repeat message',
      maxRepeatCount: 'Maximum number of repeats',
      repeatDtmf: 'DTMF for repeat',
      redirect_flag: 'Redirect call',
      callRedirectDtmf: 'For DTMF',
      redirectBeep: 'After voice message',
      redirectNumber: 'Номер',
      sms_flag: 'Send SMS',
      sendSmsEnd: 'After call',
      sendSmsDtmf: 'For DTMF',
      smsTemplateId: 'SMS template',
      dialing: 'Maximum dialing time (s)',
      retry_flag: 'Retry call',
      maxRetryCount: 'Maximum number of retried calls',
      retryInterval: 'Interval of retrying the call',
      file: 'Sound file',
      ivrmenu: 'IVR-menu',
      ttl: 'Call lifetime (s)',
    },
    call_types: {
      ivrmenu: 'IVR-menu',
      text: 'TTS',
      file: 'Sound file'
    },
    call_sound: {
      add_button: 'Upload',
      fileId: 'ID',
      name: 'Name',
      patch: 'Link',
      exist: 'File with this name already uploaded',
    }
  },

  contacts: {
    description: 'Choose file in txt, csv, xls, xlsx. The files in txt and csv should have UTF8 encoding. Fields order for automatic import: ',
    messages: {
      requiredMissing: 'It is impossible to import the file: the type "MSISDN" or "Email" must be set',
      fieldTypeDuplicates: 'Duplicate field types',
      importCount: 'Contacts uploaded: ',
      msisdnDuplicates: 'Duplicate phone numbers: ',
      failedMsisdns: 'Incorrect phone numbers: ',
      emailDuplicates: 'Duplicate e-mail addresses: ',
      failedEmails: 'Incorrect e-mail addresses: '
    },
    action: 'Action',
    action_copy: 'Copy',
    action_move: 'Move',
    action_delete: 'Delete',
    to_group: 'Destination group',
    to_blacklist: 'Destination blacklist',
    additional_actions: 'Additional',
    contacts_copied: 'Contacts copied',
    contacts_moved: 'Contacts moved',
    contacts_deleted: 'Contacts deleted',
    mSISDNDuplicates: 'Phone duplicates',
    emailDuplicates: 'Email duplicates',
    separator: 'Separator',
    file: 'File',
    autoImport: 'Automatic import',
    deleteMsisdnDuplicates: 'Check numbers for uniqueness',
    deleteEmailDuplicates: 'Check emails for uniqueness',
    fieldAssociation: 'Specify matching fields loaded',
    field: 'Field',
    type: 'Type',
    contactsCount: 'Contacts count',
    types: {
      MSISDN: 'Phone',
      EMAIL: 'E-mail',
      COMMENT: 'Comment',
      NAME: 'Name',
      SURNAME: 'Surname',
      MIDDLENAME: 'Middlename',
      FIELD1: 'Field №1',
      FIELD2: 'Field №2',
      FIELD3: 'Field №3',
      FIELD4: 'Field №4',
      FIELD5: 'Field №5',
      FIELD6: 'Field №6',
    },
    dateFormat: 'Date format for additional fields',
    dateFormats: {
      'DD-MM-YYYY': 'DD-MM-YYYY',
      'YYYY-MM-DD': 'YYYY-MM-DD',
      'MM-DD-YYYY': 'MM-DD-YYYY',
    }
  },

  distribution: {
    batchId: 'ID',
    createDatetime: 'Create date',
    startDatetime: 'Start date',
    endDatetime: 'End date',
    recipient: 'Recipients',
    start: 'Start',
    stop: 'Stop',
    pause: 'Pause',
    resume: 'Resume',
    delete: 'Delete',
    statuses: {
      GENERATED: 'Generated',
      PAYMENT_WAITING: 'Payment waiting',
      IN_PROGRESS: 'In progress',
      ON_MODERATION: 'On moderation',
      DENIED: 'Denied',
      PAUSED: 'Paused',
      STOPPED: 'Stopped',
      ERROR: 'Error',
      FINISHED: 'Finished',
    },
    dialog: {
      start: 'Start distribution?',
      stop: 'Stop distribution?',
      pause: 'Pause distribution?',
      resume: 'Resume distribution?',
    },
    messages: {
      emptyRecipients: 'Select recipients',
      incorrectNumber: 'Incorrect phone number',
      incorrectEmail: 'Incorrect e-mail',
      templateSaved: 'Template saved',
      distributionSaved: 'Distribution created',
    },
    step_template: 'Step 1: Template',
    step_message: 'Step 2: Message',
    step_recipients: 'Step {step}: Recipients',
    step_preview: 'Step {step}: Preview',
    template: 'Template',
    resetText: 'Previously entered values are stored, if You want to reset these values, click ',
    resetButton: 'Reset',
    recipients: 'Recipients',
    saveTemplate: 'Save as template',
    create: 'Create distribution',
    recipientsLabel: 'Enter the recipients separated by commas, for example: 79604564545, 79604563434',
    recipientsCount: 'All recipients of - {contacts}, Manually entered - {manual}, Selected groups - {groups}, Recipients in groups - {group_contacts}',
    totalRecipients: 'Recipients count',
    duplicatesCount: 'Duplicates',
    distributionType: 'Distribution type',
    distributionEnd: 'End datetime',
    distributionTime: {
      title: 'Dispatch time',
      period: 'from {from} to {to}',
      notSpecified: 'Send at any time',
    },
    planned: 'Scheduled ',
    immediate: 'Immediate',
    distribution: 'Send evenly',
    allowedDays: 'Allowed days to send',
    lifetime: 'Message lifetime (s)',
    blackList: 'Blacklist',
    messageType: 'Message type',
    messageLength: 'Message length',
    multiChannel: {
      title: 'Multichannel',
      enabled: 'Send after {interval} with {channel}-template {template}',
      disabled: 'Do not send to another channel',
    },
    originator: 'Sender',
    previewMessage: 'Message example',
    withoutTemplate: 'Without template',
    noLimit: 'Not limited',
    notSelected: 'Not selected',
    notSpecified: 'Not specified',
    email: {
      recipientsLabel: 'Enter the recipients addresses separated by commas, for example: test@example.com, user@example.com',
      subject: 'Subject',
      attachedFiles: 'Attachments',
      previewEmail: 'Email example',
      preview: 'Preview',
    },
    push: {
      application: 'Application',
      platform: 'Platform',
      filter: 'Filter',
    },
    call: {
      count: 'Maximum ',
      dtmf: 'for DTMF ',
      redirect: 'Redirect ',
      redirectBeep: 'after voice message',
      smsTemplate: 'With template ',
      sendSmsEnd: 'after call',
      retry: 'Call retry',
    },
    viber: {
      image: 'Image',
      button: 'Button',
    }
  },

  push_filters: {
    string: {
      empty: 'Empty',
      not_empty: 'Not empty',
      contains: 'Contains',
      not_contains: 'Not contains',
      starts: 'Starts',
      ends: 'Ends',
      equal: 'Equal',
    },
    number: {
      empty: 'Empty',
      not_empty: 'Not empty',
      equal: 'Equal',
      not_equal: 'Not equal',
      greater: 'Greater',
      greater_equal: 'Greater or equal',
      lower: 'Lower',
      lower_equal: 'Lower or equal',
      between: 'Between',
      not_between: 'Not between',
    },
    date: {
      empty: 'Empty',
      not_empty: 'Not empty',
      equal: 'Equal',
      before: 'Before',
      after: 'After',
      between: 'Between',
    },
    and: 'And',
    or: 'Or',
    attribute: 'Attribute',
    relation: 'Relation',
    value: 'Value',
    save: 'Save filter',
    incorrect: 'Filter incorrect',
    add: 'Add filter',
  },

  lang: {
    ru: 'Русский',
    en: 'English',
  },

  variable: {
    number: 'Number',
    name: 'Name',
    surname: 'Surname',
    patronymic: 'Patronymic',
    field_1: 'Field 1',
    field_2: 'Field 2',
    field_3: 'Field 3',
    field_4: 'Field 4',
    field_5: 'Field 5',
    field_6: 'Field 6',
    additional_fields: 'Additional fields'
  },

  declensions: {
    days: 'day/days/days',
    hours: 'hour/hours/hours',
    minutes: 'minute/minutes/minutes',
    seconds: 'second/seconds/seconds',
    times: 'times/times/times',
    symbols: 'symbol/symbols/symbols',
  },

  week_days: {
    MON: 'Monday',
    TUE: 'Tuesday',
    WED: 'Wednesday',
    THU: 'Thursday',
    FRI: 'Friday',
    SAT: 'Saturday',
    SUN: 'Sunday',
  },

  values: {
    priority: {
      2: 'Low',
      4: 'Normal',
      6: 'High',
      8: 'Realtime',
    },
    active: {
      all: 'All',
      active: 'Active',
      inactive: 'Not active',
      yes: 'Yes',
      no: 'No',
      1: 'Active',
      0: 'Not active',
    },
    message_status: {
      Failed: 'Failed',
      Rejected: 'Rejected',
      NotDelivered: 'Not Delivered',
      Delivered: 'Delivered',
      Deferred: 'Deferred',
      Expired: 'Expired',
      Transmitted: 'Transmitted',
      NotAnswered: 'Not Answered',
      Buffered: 'Buffered',

      Read: 'Read',
      Error: 'Error',
      Processed: 'Processed',
      Finished: 'Finished',
    },
    sender_status: {
      ACCEPTED: 'Accepted',
      UNDER_CONSIDERATION: 'Under consideration',
      DENIED: 'Denied',
    },
    report_status: {
      NEW: 'New',
      IN_PROCESS: 'In process',
      FINISHED: 'Finished',
      FAILED: 'Failed',
    },
    template_status: {
      ForModeration: 'Awaiting moderation',
      OnModeration: 'On moderation',
    },
    provider_connection_status: {
      1: 'Connected',
      0: 'Not Connected',
    },
    date: {
      min: '5 min',
      min_15: '15 min',
      hour: '1 hour',
      today: 'Today',
      yesterday: 'Yesterday',
      week: 'Week',
      month: 'Month',
    },
    group_by: {
      hour: 'Hour',
      day: 'Day',
      week: 'Week',
      month: 'Month',
      partner: 'Client',
      service_provider: 'Service provider',
      originator: 'Originator',
      template_id: 'Template ID',
      bulk_id: 'Bulk ID',
      broker_account_login: 'Account',
      application: 'Application',
      os: 'Operating system',
      message_category: 'Message category',
      message_type: 'Message type',
      country: 'Country',
      operator: 'Operator',
      mn_service_name: 'Mail Notify service',
      mn_tmpl: 'Mail Notify template',
      routes: 'Routes',
    }
  },

  sms_filter: {
    eq: 'Equal',
    noteq: 'Not equal',
    in: 'Include',
    notin: 'Not include',
  },

  restrictions: {
    alpha: 'Alphabetic only',
    numeric: 'Numeric only',
    allowed: 'Given',
  },

  dates: {
    create_date: 'Create date',
    date: 'Date',
    date_from: 'Date from',
    date_to: 'Date to',
    defer_date: 'Defer date',
    delivery_date: 'Delivery date',
    deliver_date_from: 'Deliver date from',
    deliver_date_to: 'Deliver date to',
    edit_date: 'Edit date',
    end_date: 'End date',
    end_date_from: 'Deliver date from',
    end_date_to: 'Deliver date to',
    event_date: 'Event Date',
    read_date: 'Read date',
    sent_date: 'Sent date',
    sent_date_from: 'Sent date from',
    sent_date_to: 'Sent date to',
    start_date: 'Start date',
    start_date_from: 'Create date from',
    start_date_to: 'Create date to',
  },

  statuses: {
    buffered: 'Buffered',
    deferred: 'Deferred',
    delivered: 'Delivered',
    duration: 'Duration',
    error: 'Error',
    expired: 'Expired',
    failed: 'Failed',
    finished: 'Finished',
    not_answered: 'Not answered',
    not_delivered: 'Not delivered',
    processed: 'Processed',
    read: 'Read',
    rejected: 'Rejected',
    statuses: 'Statuses',
    transmitted: 'Transmitted',
  },

  descriptions: {
    deferred: 'Messages will be sent later',
    delivered: 'Messages were delivered to the subscriber',
    expired: "Messages have been sent to the service provider, their lifetime expired in the provider's queue",
    failed: 'An error occurred while trying to send a message',
    not_delivered: 'Messages were not delivered to the subscriber. Final status',
    rejected: 'Messages were rejected by the platform',
    read: 'Messages have been read',
    total: 'Total number of messages',
    transmitted: 'Messages have been sent to the service provider, but the delivery status has not yet been received',
    partner_price: 'Client price',
    provider_price: 'Service provider price',
  },

  helps: {
    template_activity_html: 'Start and end dates of the template.<ul>' +
      '<li>If the start date is not filled in, then the template will take effect immediately. If filled in, the template will take effect from the specified date.</li>' +
      '<li>If the end date is not filled in, then the validity period of the template is not limited. If it is filled in, then the template will cease to be valid on the specified date.</li></ul>',
    template_timeout_html: '<ul><li>Some text for template timeout help</li></ul>',
    tariff_zones_group_settings: 'Please set up a group of tariff zones',
    tariff_zones_create: 'Create a new tariff zone',
  },
};

export default messages;
